<template>
    <div>
        <div class="nav">
              <ul class="list3">
                  <li><el-button size="large" color="#e8f2ff"  tag="a" href="/"><el-icon><House /></el-icon>首页</el-button></li>
                  <li v-if="classify == '高考资料'"><el-button  size="large" color="#5cbaf6" type="primary" style="color:#ffffff ;background: linear-gradient(to top, #47a8f3,#6ac7f8);" tag="a" href="/gkzl"><el-icon style="color: #ffffff;"><Coin /></el-icon>高考资料</el-button></li>
                  <li v-if="classify != '高考资料'"><el-button  size="large" color="#e8f2ff" tag="a" href="/gkzl"><el-icon><Coin /></el-icon>高考资料</el-button></li>
                  <li v-if="classify == '自考教材'"><el-button size="large" type="primary"  color="#5cbaf6" style="color:#ffffff ;background: linear-gradient(to top, #47a8f3,#6ac7f8);" tag="a" href="/zkjc"><el-icon style="color: #ffffff;"><Reading /></el-icon>自考教材</el-button></li>
                  <li v-if="classify != '自考教材'"><el-button  size="large" color="#e8f2ff" tag="a" href="/zkjc"><el-icon><Reading /></el-icon>自考教材</el-button></li>
                  <li v-if="classify == '书法教材'"><el-button size="large" type="primary" color="#5cbaf6" style="color:#ffffff ;background: linear-gradient(to top, #47a8f3,#6ac7f8);" tag="a" href="/sfjc"><el-icon style="color: #ffffff;"><EditPen /></el-icon>书法教材</el-button></li>
                  <li v-if="classify != '书法教材'"><el-button size="large" color="#e8f2ff"  tag="a" href="/sfjc"><el-icon><EditPen /></el-icon>书法教材</el-button></li>
                  <li v-if="classify == '报刊杂志'"><el-button size="large" type="primary" color="#5cbaf6" style="color:#ffffff ;background: linear-gradient(to top, #47a8f3,#6ac7f8);" tag="a" href="/bkzz"><el-icon style="color: #ffffff;"><DocumentCopy /></el-icon>报刊杂志</el-button></li>
                  <li v-if="classify != '报刊杂志'"><el-button size="large" color="#e8f2ff" tag="a" href="/bkzz"><el-icon><DocumentCopy /></el-icon>报刊杂志</el-button></li>
                  <li v-if="classify == '特价图书'"><el-button size="large" type="primary" color="#5cbaf6" style="color:#ffffff ;background: linear-gradient(to top, #47a8f3,#6ac7f8);" tag="a" href="/tjts"><el-icon style="color: #ffffff;"><CollectionTag /></el-icon>特价图书</el-button></li>
                  <li v-if="classify != '特价图书'"><el-button size="large" color="#e8f2ff" tag="a" href="/tjts"><el-icon><CollectionTag /></el-icon>特价图书</el-button></li>
                  <li v-if="classify == '成绩证书'"><el-button size="large" type="primary" color="#5cbaf6" style="color:#ffffff ;background: linear-gradient(to top, #47a8f3,#6ac7f8);" tag="a" href="/cjzs"><el-icon style="color: #ffffff;"><Notebook /></el-icon>成绩证书</el-button></li>
                  <li v-if="classify != '成绩证书'"><el-button size="large" color="#e8f2ff" tag="a" href="/cjzs"><el-icon><Notebook /></el-icon>成绩证书</el-button></li>
                  <li v-if="classify == '其他'"><el-button size="large"  type="primary" color="#5cbaf6" style="color:#ffffff ;background: linear-gradient(to top, #47a8f3,#6ac7f8);" tag="a" href="/others"><el-icon style="color: #ffffff;"><Menu /></el-icon>其他</el-button></li>
                  <li v-if="classify != '其他'"><el-button size="large" color="#e8f2ff" tag="a" href="/others"><el-icon><Menu /></el-icon>其他</el-button></li>
              </ul>
          </div>
          <div class="tags">
            <div style="width: 7px;height: 7px;background-color: orange;"></div>
            <div style="width: 7px;height: 33px;background-color:#49aef1 ; margin-top: 6px;"></div>
            <div class="tag1">热销图书</div>
            <div class="triangle"></div>
            <div class="tag"></div>
            <hr>
        </div>
        <div class="book">
            <ul class="list5">
                <li v-for="item in BookList" :key="item.ID" >
                   <a @click="getBookId(item.ID)"> <div class="bookImg"><el-image v-if="item.IMG_COVER" :src="item.IMG_COVER[0]" /></div><p class="bookTitle">{{ item.NAME }}</p><p class="bookPrice"><span>￥</span>{{ item.PRICE }}</p></a>
                </li>
            </ul>
        </div>
        <div class="pagination">
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="currentPage"     @current-change="handleCurrentChange"
             />
        </div>
    </div>
</template>

<script>
import {ref} from 'vue'

export default {
    name: 'BookMore',
    setup(){
        const total = ref(150)
        const pageSize = ref(15)
        const currentPage = ref(1)
        return{
            total,
            pageSize,
            currentPage
        }
    },
    props: {
        ishot: String,
        classify: String
    },
    methods: {
        getBookList(page,num) {
            this.$axios.post('/api/Book/MoreBooklist',{
                category: this.classify,
                ishot: this.ishot,
                page: page,
                num: num
            }).then(res=>{
                res.data.BookList.forEach(item => {
                    item.IMG_COVER = item.IMG_COVER.split(',');
                });
                this.BookList = res.data.BookList;
                this.total = res.data.Total;
            })
        },
        getBookId(id){
                let url = '/bookdetail/'+id;
                if(this.classify == 'cjzs' || this.classify == '成绩证书'){
                    url = '/cjzsdetail/'+id;
                }
                window.open(url);
        },
        handleCurrentChange(val){
            this.currentPage = val;
            this.getBookList(val,this.pageSize)
        }
    },
    data() {
        return {
            BookList: []
        }
    },
    created() {
        this.getBookList(1,15)
    }

}

</script>

<style scoped>
.el-pagination{
    margin-top: 20px;
    float: right;
}
.pagination{
    margin-right: 320px;
    float: right;
}


.bookPrice{
    margin-top: 20px;
    color: #db444a;
    font-size: 25px;
    font-weight: bold;
    margin-right: 50px;
}
.bookPrice span{
    font-size: 16px;
    font-weight: bold;
}
.bookTitle{
    width: 210px;
    height: 40px;
    margin-top: 20px;
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.bookImg{
    width: 220px;
    height: 230px;
    border: rgb(204, 199, 199) solid 1px;
    border-radius: 6px;
}
.list5{
    list-style-type: none;
    float: left;
    margin-left: 225px;
    margin-top: 20px;
    height: 1200px;
    width: 1350px;
}
.list5 li{
    float: left;
    width: 270px;
    height: 380px;
    padding-left: 25px;
    margin-top: 20px;
    border-radius: 6px;
}
.list5 .el-image{
    width: 150px;
    height: 190px;
    margin-top: 20px;
}
.list5 li a{
    text-decoration: none;
    color: #464545;
}
.list5 li:hover{
    box-shadow: 0 0 10px #ccc;
}
.list5 li:hover .bookImg{
    border: rgb(204, 199, 199);
}

  .el-icon{
      font-size: 25px;
      margin-right: 10px;
      color: #49aef1;
  }
  
  .list3 .el-button{
      width: 161px;
      height: 46px;
      font-size: 16px;
      border-radius: 7px;
      color: #000;
      margin-top: 1px;
      padding-left: 10px;
      background: linear-gradient(to top, #deedff,#f3f8ff);
  }
  .list3 {
      list-style-type: none;
      float: left;
      margin-left: 240px;
      margin-top: 5px;
      height: 60px;
  }
  
  .list3 li {
      float: left;
      font-size: 20px;
      margin-left: 20px;
      width: 165px;
      height: 50px;
      font-weight: bold;
      border-radius: 7px;
      display: block;
      color: #49aef1;
      border: #c3d1db solid 1px;
  }
  .list3 a{
      text-decoration: none;
      color: #49aef1;
  }
 .nav .el-button:hover {
      background: linear-gradient(to top, #47a8f3,#6ac7f8);
      color: #ffffff;
  }
  
 .nav .el-button:hover .el-icon {
      color: #ffffff;
  }

  hr{
    width: 1160px;
    margin-left: 140px;
    margin-top: -2px;
    border: 1px solid #efefef;
}
.tags{
    width: 1600px;
    float: left;
    height: 46px;
    margin-left: 250px;
    margin-top: 10px;
}
.tag1{
    font-size: 20px;
    color: #ffffff;
    width: 110px;
    height: 46px;
    margin-top: -46px;
    margin-left: 15px;
    position: relative;
    padding-top: 10px;
    background: linear-gradient(to top, #47a8f3,#6ac7f8);
}
.triangle{
    width: 25px;
    height: 46px;                                       
    margin-left: 125px;
    clip-path: polygon(0 0, 0 100%, 50% 100%);
    margin-top: -46px;
    background: linear-gradient(to top, #47a8f3,#6ac7f8)
}
.tag{
    width: 800px;
    float: left;
    height: 26px;
    margin-left: 138px;
    background-color: #efefef;
    margin-top: -35px;
    background: repeating-linear-gradient(145deg, white, white 2px, #efefef 2px, #efefef 4px) ;
    mask-image: linear-gradient(to left, transparent 0%, black 60%);
    transform: skew(19deg);
}
</style>
